import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { Domain, MessageConst } from 'enums'
import { AutomationId } from 'utils/automationUtil'
import StreamSymbol from 'enums/StreamSymbol'

// @ts-ignore
import { sys } from '@netbasequid/theme'
import {
  StyledTooltipContentContainer,
  StyledTooltipContentLeft,
  StyledTooltipContentLeftItem,
  StyledTooltipContentRight,
  StyledTooltipContentRightItem
} from './index.css'
import MediaCardContext from '../mediaCardContext'
import { getTooltipNumberFormatter } from '../utils'
import { MetricsMapping, IconMapping } from '../constant'

const FooterTooltip = ({ children }: { children: any }) => {
  const { mode, domain, footer, dataStream } = useContext(MediaCardContext)
  const isPodcast = dataStream === StreamSymbol.PODCAST
  // eslint-disable-next-line no-nested-ternary
  const source = isPodcast ? StreamSymbol.PODCAST : domain!
  const { t } = useTranslation()

  return (
    <Tooltip
      mode={mode}
      followCursor
      enabled
      content={
        <StyledTooltipContentContainer>
          <StyledTooltipContentLeft>
            {MetricsMapping[source!].metrics
              .filter((item) => {
                if (domain === Domain.TWITTER && footer.get(item) === undefined) {
                  return false
                }
                return true
              })
              .map((item) => (
                <StyledTooltipContentLeftItem
                  key={IconMapping[item].label}
                  mode={mode}
                  data-testid={AutomationId.mediaCard.footerTooltip.metricsName}>
                  {IconMapping[item].getIcon(12, mode, sys[mode].text.weak, domain)}
                  {t(IconMapping[item].label)}
                </StyledTooltipContentLeftItem>
              ))}
          </StyledTooltipContentLeft>
          <StyledTooltipContentRight
            data-testid={AutomationId.mediaCard.footerTooltip.metricsValue}>
            {MetricsMapping[source!].metrics
              .filter((item) => {
                if (domain === Domain.TWITTER && footer.get(item) === undefined) {
                  return false
                }
                return true
              })
              .map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <StyledTooltipContentRightItem mode={mode} key={index}>
                  {footer.get(item) !== (undefined || null) && typeof footer.get(item) === 'number'
                    ? getTooltipNumberFormatter().format(footer.get(item)!)
                    : MessageConst.EM_DASH}
                </StyledTooltipContentRightItem>
              ))}
          </StyledTooltipContentRight>
        </StyledTooltipContentContainer>
      }>
      {children}
    </Tooltip>
  )
}

export default FooterTooltip
